import React from 'react';

import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';
import Skeleton from 'react-loading-skeleton';

LazyLoadWithSkeleton.propTypes = {
  borderRadius: PropTypes.number | PropTypes.string,
  children: PropTypes.element,
  className: PropTypes.string,
};

function LazyLoadWithSkeleton({ borderRadius, children, className = '' }) {
  return (
    <LazyLoad
      className={className}
      debounce={true}
      offset={300}
      placeholder={
        <Skeleton
          borderRadius={borderRadius}
          containerClassName='skeleton-container'
          count={1}
          height='100%'
          width='100%'
        />
      }
    >
      {children}
    </LazyLoad>
  );
}

export default LazyLoadWithSkeleton;
